import { Component, OnInit } from '@angular/core';
import { StationInventoryService } from '../app-modules/dashboard/components/station-inventory/station-inventory.service';

@Component({
  selector: 'app-inventory-tank-details',
  templateUrl: './inventory-tank-details.component.html',
  styleUrls: ['./inventory-tank-details.component.css', '../scrollbar.scss' ]
})
export class InventoryTankDetailsComponent implements OnInit {

  selectedItem: any;
  readings: any[];
  deliveries: any;

  constructor(private stationInventoryService: StationInventoryService) { }

  ngOnInit(): void {
    console.log("Selected item", this.selectedItem);
    console.log("Readings history received", this.readings);
    console.log("Deliveries", this.deliveries);
  }

  close(clicker){
    this.stationInventoryService.closeModal();
  }

}
